import { BILLING_INTERVAL } from "@/data/constants";
import { TLedgerEligibilityParams } from "../types.dashboard";

/**
 * Ledger is for monthly V2 users only. V1 has no ledger, and localised regions
 * skip it because invoices may be in a different currency than the plan.
 */
export function isLedgerEligible({
  billingPeriod,
  isV1 = false,
  isLocalisedPricing,
}: TLedgerEligibilityParams): boolean {
  return (
    billingPeriod === BILLING_INTERVAL.MONTHLY && !(isV1 || isLocalisedPricing)
  );
}
